import type { LINE_HEIGHT_MAP } from '@elfsight/widget-utils';
import { getLineHeight } from '@elfsight/widget-utils';

export type TypographyFontSizes = keyof typeof LINE_HEIGHT_MAP;
export type TypographyToken = `text${TypographyFontSizes}${'Bold' | ''}`;

export function getTokenFontStyle(token: TypographyToken) {
  const fontWeight = token.endsWith('Bold') ? 700 : 400;
  const fontSize = FONT_SIZES_MAP[token];
  const lineHeight = getLineHeight({ fontSize });

  return { fontSize, fontWeight, lineHeight, fontStyle: 'normal' as const };
}

export const FONT_SIZES_MAP = {
  text36: 36,
  text32: 32,
  text28: 28,
  text24: 24,
  text22: 22,
  text20: 20,
  text19: 19,
  text18: 18,
  text17: 17,
  text16: 16,
  text15: 15,
  text14: 14,
  text13: 13,
  text12: 12,
  text11: 11,
  text8: 8,

  text36Bold: 36,
  text32Bold: 32,
  text28Bold: 28,
  text24Bold: 24,
  text22Bold: 22,
  text20Bold: 20,
  text19Bold: 19,
  text18Bold: 18,
  text17Bold: 17,
  text16Bold: 16,
  text15Bold: 15,
  text14Bold: 14,
  text13Bold: 13,
  text12Bold: 12,
  text11Bold: 11,
  text8Bold: 8
} as const;
